import { getGenericEndpoint } from './get.api';
import type { GetRequiredInfoResponse } from './types';

export const getRequiredInfo = async (lang?: string) => {
	return await getGenericEndpoint<GetRequiredInfoResponse>(
		'signin/required-info',
		lang
	);
};
